import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2, ShieldCheck } from "lucide-react";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../components/ui/table";

export default function Compliance() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/compliance/checklist").then((r) => setData(r.data)); }, []);

  return (
    <Layout breadcrumbs={["SSRD", "Compliance"]}>
      <div className="mb-6">
        <div className="text-[10px] tracking-widest text-muted-foreground uppercase">DPDP & Compliance</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-testid="compliance-title">Compliance Settings</h1>
      </div>

      <div className="rounded-md border border-border bg-secondary/30 p-4 text-sm leading-relaxed mb-6" data-testid="compliance-statement">
        {data?.statement}
      </div>

      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-6">
        <Card data-testid="compliance-checklist"><CardContent className="p-5">
          <div className="text-[10px] tracking-widest text-muted-foreground uppercase mb-3">Operational checklist</div>
          <ul className="space-y-2">
            {(data?.items || []).map((i) => (
              <li key={i.key} className="flex items-center gap-3 text-sm">
                <CheckCircle2 className={`size-4 ${i.status ? "text-emerald-700" : "text-amber-700"}`} />
                <span>{i.label}</span>
              </li>
            ))}
          </ul>
        </CardContent></Card>

        <Card data-testid="retention-policies"><CardContent className="p-0">
          <div className="px-5 py-3 border-b border-border flex items-center gap-2">
            <ShieldCheck className="size-4 text-primary" />
            <div className="text-lg font-semibold">Retention Policies</div>
          </div>
          <Table>
            <TableHeader><TableRow>
              <TableHead>Category</TableHead><TableHead>Retention</TableHead>
              <TableHead>Archival</TableHead><TableHead>Deletion</TableHead><TableHead>Status</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {(data?.policies || []).map((p) => (
                <TableRow key={p.retention_policy_id}>
                  <TableCell className="text-xs font-medium">{p.data_category}</TableCell>
                  <TableCell className="text-xs">{p.retention_period}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{p.archival_rule}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{p.deletion_rule}</TableCell>
                  <TableCell className="text-xs">{p.policy_status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent></Card>
      </div>
    </Layout>
  );
}
